<template>
  <WithSpinnerLoading :loading="loading" class="match-type-column-content">
    {{ matchingTypeLabel }}
    <ElPopover
      v-if="!readOnly"
      v-model="formVisible"
      placement="top"
      trigger="click"
    >
      <MatchTypeColumnContentForm
        :initial-matching-type="matchingType"
        @save="closeAndSaveBid"
        @close="closePopover"
      />
      <i v-show="isHovered" slot="reference" class="el-icon-edit pointer" />
    </ElPopover>
  </WithSpinnerLoading>
</template>

<script>
import MatchTypeColumnContentForm from './MatchTypeColumnContentForm';
import WithSpinnerLoading from '@@/advertisement/common/WithSpinnerLoading';

import campaignId from '@/mixins/advertisement/campaignId';

import { CHANGE_BID_MATCHING_TYPE } from '@/store/types';
import { mapActions } from 'vuex';

import translateMatchingType from '../../../../utility/translators/translateMatchingType';

export default {
  name: 'MatchTypeColumnContent',
  components: {
    MatchTypeColumnContentForm,
    WithSpinnerLoading,
  },
  mixins: [campaignId],
  props: {
    isHovered: {
      type: Boolean,
      required: true,
    },
    matchingType: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formVisible: false,
      loading: false,
    };
  },
  computed: {
    matchingTypeLabel() {
      return translateMatchingType(this.matchingType);
    },
  },
  methods: {
    ...mapActions({
      changeMatchingType: CHANGE_BID_MATCHING_TYPE,
    }),
    closePopover() {
      this.formVisible = false;
    },
    closeAndSaveBid(matchingType) {
      this.closePopover();

      this.loading = true;

      return this.changeMatchingType({
        id: this.id,
        campaignId: this.campaignId,
        matchingType: matchingType,
      })
        .then(message => {
          this.$message.success(message);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss">
.match-type-column-content {
  display: flex;
  justify-content: space-between;
}
</style>
